import { createFileRoute } from "@tanstack/react-router";
import { buildRouteHead } from "@/lib/seo/routeHead";
import SolutionDetail from "@/pages/SolutionDetail";

export const Route = createFileRoute("/en/industries/combination-products")({
  head: () => buildRouteHead("/en/industries/combination-products"),
  component: SolutionDetail,
});

